import React from 'react';

import Step from 'components/stepper/Step';
import Protected from 'components/Protected';

const UnauthenticatedStep = ({ exitPage, pageTitle }) => {
  return (
    <Step
      spacing={8}
      onBackButtonClick={exitPage}
      stepTitle={pageTitle}
      renderBody={() => <Protected></Protected>}
    ></Step>
  );
};

export default UnauthenticatedStep;
